class MegamenuTabbed extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('mouseenter', () => this.activate(tab.dataset.tab));
      tab.addEventListener('focus', () => this.activate(tab.dataset.tab));
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        this.activate(tab.dataset.tab);
      });
    });
  }

  activate(id) {
    this.tabs.forEach((tab) => {
      tab.setAttribute('aria-selected', tab.dataset.tab === id ? 'true' : 'false');
    });
    this.panels.forEach((panel) => {
      if (panel.dataset.panel === id) {
        panel.setAttribute('data-active', '');
        panel.removeAttribute('aria-hidden');
      } else {
        panel.removeAttribute('data-active');
        panel.setAttribute('aria-hidden', 'true');
      }
    });
  }
}

if (!customElements.get('megamenu-tabbed')) {
  customElements.define('megamenu-tabbed', MegamenuTabbed);
}
